import React from "react";
import styled from "styled-components/macro";
import FooterSection from "./FooterSection";

interface AddressSectionProps {
  store: any;
}

const AddressSection: React.FC<AddressSectionProps> = ({ store }) => {
  const address = store.footer ? store.footer.address : store.address;
  const phones = store.footer
    ? store.footer.phones
    : [store.tel1, store.tel2].filter(Boolean);

  return (
    <FooterSection title={store.title}>
      <AddressData>
        <Text className="text-sm">{store.city}</Text>
        {address && <Text className="text-sm">{address}</Text>}
        {phones.map((phone: string) => (
          <PhoneLink
            key={phone}
            className="text-sm"
            href={`tel:${phone.replace(/[^\d+]/g, "")}`}
            aria-label={`Обадете се на ${phone}`}
          >
            {phone}
          </PhoneLink>
        ))}
      </AddressData>
      {/* <Map>
        <iframe
          src={store.iframeSrc}
          title={store.iframeSec}
          width="100%"
          height="100%"
          frameBorder="0"
          style={{ border: "0" }}
          aria-hidden="false"
          tabIndex={0}
        ></iframe>
      </Map> */}
    </FooterSection>
  );
};

const AddressData = styled.div`
  height: 80px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
const Map = styled.div`
  margin-top: 30px;
  width: 100%;
  height: 200px;
`;

const Text = styled.span`
  color: white;
`;

const PhoneLink = styled.a`
  color: white;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    border-radius: 2px;
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }
`;
export default AddressSection;
